import { TabPanels as ChakraTabPanels, TabPanelsProps } from '@chakra-ui/react'
import { withShade } from './core/utils'

export const TabPanels = withShade<TabPanelsProps>(ChakraTabPanels)
